// Shared helpers for the analysis dialogs (Full Analysis / Compare Answers)
// so the same behaviour is reused across the coaching task cards and the
// View Syllabus modal instead of being duplicated per surface.

export const parseQuestionNumber = (questionNumber, fallbackIndex = 0) => {
  const parsed = Number(questionNumber);
  if (Number.isFinite(parsed)) {
    return parsed;
  }
  const matched = `${questionNumber ?? ''}`.match(/\d+/);
  return matched ? Number(matched[0]) : fallbackIndex + 1;
};

export const getResultType = (analysis) => {
  if (!analysis) return 'incorrect';

  const isCorrectValue = analysis.is_correct === true || analysis.is_correct === 'correct';
  if (isCorrectValue) {
    return 'correct';
  }

  const partialCredit = Number(analysis.partial_credit || 0);
  if (partialCredit > 0) {
    return 'partial';
  }

  return 'incorrect';
};

// Render KaTeX inside the most recently opened modal once it mounts. Mirrors
// the inline effect previously kept in CoachingTasksSection.
export const renderModalKatex = () => {
  if (!window.renderMathInElement) return;
  setTimeout(() => {
    const modalContent = document.querySelector('.fixed.inset-0');
    if (!modalContent) return;
    try {
      window.renderMathInElement(modalContent, {
        delimiters: [
          { left: '$$', right: '$$', display: true },
          { left: '$', right: '$', display: false },
          { left: '\\[', right: '\\]', display: true },
          { left: '\\(', right: '\\)', display: false },
        ],
        throwOnError: false,
        errorColor: '#cc0000',
        strict: false,
      });
    } catch (error) {
      console.error('Error rendering KaTeX in analysis modal:', error);
    }
  }, 100);
};
